<template>
  <div class="message-list" v-if="visible" @click.stop="">
    <!-- 消息标题栏 统一处理，param中叫imageUrl的统一处理成图片 -->
    <div class="message-title">
      <div class="message-left">
        <table-button :class="searchInfo.status === ''? 'active': ''" :disabled="searchInfo.status === ''" @click="filterMessageType('')">全部</table-button>
        <table-button :class="searchInfo.status === '0'? 'active': ''" :disabled="searchInfo.status === '0'" @click="filterMessageType('0')">未读</table-button>
        <table-button :class="searchInfo.status === '1'? 'active': ''" :disabled="searchInfo.status === '1'" @click="filterMessageType('1')">已读</table-button>
      </div>
      <div class="message-right">
        <el-checkbox :indeterminate="indeterminateMessage" v-model="checkAllMessage" @change="handleCheckAllMessage" />
        <table-button @click="markAllAsRead">标记已读</table-button>
        <yq-icon name="element-ui_delete" @click="toDeleteAll" style="color: var(--el-color-danger)"/>
      </div>
    </div>

    <!-- 消息列表内容 -->
    <div class="message-list-info">
      <div
        class="message-container"
        v-infinite-scroll="loadMoreMessages"
        :infinite-scroll-disabled="loadingMessage || !hasMoreMessage"
        infinite-scroll-distance="10"
      >
        <!-- 空状态 -->
        <div v-if="messageList.length === 0 && !loadingMessage" class="message-empty">
          <div class="empty-icon">📭</div>
          <div class="empty-text">暂无消息</div>
        </div>

        <!-- 消息项 -->
        <div
          v-for="(item, i) in messageList"
          class="message-item"
          :class="{'read': item.isRead === 'Y', 'expanded': item.expanded}"
          :key="item.id || i"
        >
          <!-- 已读/未读状态 -->
          <div class="message-status" @click.stop="">
            <span
              class="status-badge"
              :class="item.messageStatus === 1 ? 'read-badge' : 'unread-badge'"
              :title="item.messageStatus === 1 ? '已读' : '未读'"
            ></span>
            <span class="status-type">
              <span v-if="item.messageType === 1">通知</span>
              <span v-if="item.messageType === 2">预警</span>
            </span>
          </div>

          <!-- 复选框 -->
          <div class="message-check" @click.stop="">
            <el-checkbox v-model="item.checked" @change="changeMessage"/>
          </div>

          <!-- 消息详情 -->
          <div class="message-detail" @click="toggleMessageExpand(item)">
            <!-- 消息头部 -->
            <div class="detail-header">
              <div class="detail-title">
                <!-- 预警级别标签 (仅预警消息显示) -->
                <el-tag v-if="item.warnType === 'XJ_WARN'" small type="warning" class="warn-tag">巡检预警</el-tag>
                <el-tag v-else-if="item.warnType === 'ATTEND_WARN'" small type="info" class="warn-tag">考勤预警</el-tag>
                <el-tag v-else-if="item.warnType === 'VIDEO_WARN'" small type="warning" class="warn-tag">陌生人打卡</el-tag>
                <el-tag v-else-if="item.warnType === 'WORKER_WARN'" small type="danger" class="warn-tag">设备异常</el-tag>
                <el-tag v-else-if="item.warnType === 'WORKER_WARN'" small type="danger" class="warn-tag">设备异常</el-tag>
                <el-tag v-else-if="item.noticeType === '1'" small type="success" class="warn-tag">通知</el-tag>
                <el-tag v-else-if="item.noticeType === '2'" small type="primary" class="warn-tag">公告</el-tag>
                <el-tag v-else-if="item.noticeType === '3'" small type="info" class="warn-tag">系统消息</el-tag>
                <!-- 重要级别标签 -->
                <span
                  class="message-level-tag"
                  v-if="item.level && item.level !== '1'"
                  :class="'level-' + item.level"
                >
                  {{ getLevelText(item.level) }}
                </span>

                <!-- 标题文本 -->
                <span class="title-text">{{ item.messageTitle }}</span>

                <!-- 展开/收起图标 -->
                <yq-icon
                  :name="item.expanded ? 'element-ui_arrow-up' : 'element-ui_arrow-down'"
                  class="expand-icon"
                />
              </div>
              <div class="detail-time">{{ formatTime(item.messageTime) }}</div>
            </div>

            <!-- 收起状态：内容预览 -->
            <div class="detail-info" v-if="!item.expanded">
              <span class="content-preview">{{ getShortContent(item.messageContent) }}</span>
              <span class="view-detail-btn" @click.stop="openMessageDetail(item)">查看详情</span>
            </div>

            <!-- 展开状态：完整内容 -->
            <div class="detail-content" v-if="item.expanded">
              <div class="content-full-wrapper" :class="{'has-overflow': item.hasOverflow}">
                <!-- 富文本内容（通知公告和预警） -->
                <div
                  class="content-full"
                  v-html="item.messageContent"
                  :ref="'content-' + item.id"
                ></div>
              </div>

              <!-- 元信息 -->
              <div class="content-meta">
                <span v-if="item.publisherName">发布人：{{ item.publisherName }}</span>
                <span v-if="item.time">发布时间：{{ item.time }}</span>
                <span v-if="item.messageType === 'warn' && item.statusName">
                  状态：<el-tag :type="getStatusTagType(item.status)" size="small">{{ item.statusName }}</el-tag>
                </span>
              </div>

              <!-- 操作按钮 -->
              <div class="detail-actions">
                <span class="view-detail-btn" @click.stop="openMessageDetail(item)">查看完整详情</span>

                <!-- 预警消息的跳转按钮 -->
                <span
                  v-if="item.messageType === 'warn' && item.pagePath"
                  class="jump-btn"
                  @click.stop="jumpToPage(item)"
                >
                  跳转处理
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 加载中提示 -->
      <div class="message-loading" v-if="loadingMessage">加载中...</div>

      <!-- 没有更多提示 -->
      <div class="message-no-more" v-if="!hasMoreMessage && messageList.length > 0">没有更多了</div>
    </div>

    <!-- 消息详情对话框 -->
    <el-dialog
      v-model="showMessageDetail"
      :title="currentMessage.messageTitle"
      width="600px"
      class="message-detail-dialog"
      :close-on-click-modal="false"
    >
      <div class="dialog-header-info">
        <span class="message-type-tag" :class="'tag-' + currentMessage.messageType">
          {{ getMessageTypeText(currentMessage.messageType) }}
        </span>
        <el-tag v-if="currentMessage.warnType === 'XJ_WARN'" small type="warning" class="warn-tag">巡检预警</el-tag>
        <el-tag v-else-if="currentMessage.warnType === 'ATTEND_WARN'" small type="info" class="warn-tag">考勤预警</el-tag>
        <el-tag v-else-if="currentMessage.warnType === 'VIDEO_WARN'" small type="warning" class="warn-tag">陌生人打卡</el-tag>
        <el-tag v-else-if="currentMessage.warnType === 'WORKER_WARN'" small type="danger" class="warn-tag">设备异常</el-tag>
        <el-tag v-else-if="currentMessage.noticeType === '1'" small type="success" class="warn-tag">通知</el-tag>
        <el-tag v-else-if="currentMessage.noticeType === '2'" small type="primary" class="warn-tag">公告</el-tag>
        <el-tag v-else-if="currentMessage.noticeType === '3'" small type="info" class="warn-tag">系统消息</el-tag>
        <span
          class="message-level-tag"
          v-if="currentMessage.level && currentMessage.level !== '1'"
          :class="'level-' + currentMessage.level"
        >
          {{ getLevelText(currentMessage.level) }}
        </span>
      </div>

      <div class="dialog-content">
        <div style="white-space: pre-wrap"
          v-if="currentMessage.messageType === 1 || currentMessage.messageType === 2"
          v-html="currentMessage.messageContent"
        ></div>
        <div v-else>{{ currentMessage.messageContent }}</div>
      </div>

      <div class="dialog-meta">
        <div v-if="currentMessage.publisherName">
          <label>发布人：</label>{{ currentMessage.publisherName }}
        </div>
        <div v-if="currentMessage.messageTime">
          <label>发布时间：</label>{{ currentMessage.messageTime }}
        </div>
        <div v-if="currentMessage.messageType === 2">
          <label>状态：</label>
          <el-tag v-if="currentMessage.status === '1'" size="small" type="warning">待处理</el-tag>
          <el-tag v-else-if="currentMessage.status === '2'" size="small" type="warning">处理中</el-tag>
          <el-tag v-else-if="currentMessage.status === '3'" size="small" type="success">处理完成</el-tag>
          <el-tag v-else-if="currentMessage.status === '4'" size="small" type="info">已忽略</el-tag>
        </div>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <page-button @click="showMessageDetail = false">关闭</page-button>
          <page-button v-if="currentMessage.actionType === 'DEAL'">跳转处理</page-button>
        </div>
      </template>

    </el-dialog>
  </div>
</template>

<script>
import TableButton from '@/components/h5/button/TableButton.vue';
import PageButton from '@/components/h5/button/PageButton.vue';
import YqIcon from '@/components/YqIcon.vue';
import messageApi from "@/api/dz-luqiao/messageApi";
import util from '@/util/util';
import {useRoute, useRouter} from "vue-router";

export default {
  emits: ["readMessage", "updateCount", "close"],
  name: 'MessageList',
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  components: {
    TableButton,
    PageButton,
    YqIcon
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      messageType: 'all',
      messageList: [],
      checkAllMessage: false,
      indeterminateMessage: false,
      loadingMessage: false,
      hasMoreMessage: true,
      currentPage: 1,
      pageSize: 10,
      showMessageDetail: false,
      currentMessage: {},
      userInfo: {} , // 用户信息
      searchInfo: {
        pageNumber: 1
      },
    };
  },
  async created() {
    // 获取用户信息
    this.userInfo = await util.getUserInfo();
  },
  watch: {
    visible(val) {
      if (val) {
        this.resetMessageList();
        this.fetchMessages();
        // 延迟添加点击外部关闭的监听
        this.$nextTick(() => {
          setTimeout(() => {
            document.addEventListener('click', this.handleClickOutside);
          }, 100);
        });
      } else {
        // 移除监听
        document.removeEventListener('click', this.handleClickOutside);
      }
    }
  },
  beforeUnmount() {
    // 组件销毁时移除监听
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    /**
     * 处理点击外部关闭
     */
    handleClickOutside() {
      this.$emit('close');
    },

    /**
     * 获取消息列表
     */
    async fetchMessages() {
      if (this.loadingMessage) {
        console.log("正在加载中，请勿重复点击...");
        return;
      }
      console.log('MessageList - 获取消息列表...');
      this.loadingMessage = true;
      messageApi.myWarnMessageList(this.searchInfo).then(res => {
        let list = res.records;
        this.messageList = list;
        this.hasMoreMessage = res.pageCount > this.searchInfo.pageNumber;
        this.loadingMessage = false;
      });
    },


    /**
     * 筛选消息类型
     */
    filterMessageType(type) {
      this.messageType = type;
      this.searchInfo.status = type;
      this.resetMessageList();
      this.fetchMessages();
    },

    /**
     * 重置消息列表
     */
    resetMessageList() {
      this.searchInfo.pageNumber = 1;
      this.messageList = [];
      this.currentPage = 1;
      this.hasMoreMessage = true;
      this.checkAllMessage = false;
      this.indeterminateMessage = false;
    },

    /**
     * 加载更多消息
     */
    loadMoreMessages() {
      if (!this.hasMoreMessage || this.loadingMessage) return;
      this.searchInfo.pageNumber ++;
      this.fetchMessages();
    },

    /**
     * 全选/取消全选
     */
    handleCheckAllMessage(val) {
      this.messageList.forEach(item => {
        item.checked = val;
      });
      this.indeterminateMessage = false;
    },

    /**
     * 单个消息勾选变化
     */
    changeMessage() {
      const checkedCount = this.messageList.filter(item => item.checked).length;
      this.checkAllMessage = checkedCount === this.messageList.length;
      this.indeterminateMessage = checkedCount > 0 && checkedCount < this.messageList.length;
    },

    /**
     * 批量标记已读
     */
    async markAllAsRead() {
      // 筛选出已勾选且未读的消息
      const checkedMessages = [];
      for (let i = 0; i < this.messageList.length; i++) {
        if (this.messageList[i].checked && this.messageList[i].messageStatus === 0) {
          checkedMessages.push({readLogId: this.messageList[i].readLogId, id: this.messageList[i].id, messageType: this.messageList[i].messageType})
        }
      }
      if (checkedMessages.length === 0) {
        this.$message.warning('请选择未读消息');
        return;
      }
      console.log(`批量标记 ${checkedMessages.length} 条消息为已读`);
      messageApi.readWarnMessage(checkedMessages).then(() => {
        this.resetMessageList();
        this.fetchMessages();
        this.$emit("readMessage", checkedMessages.length);// 重新刷新未读消息
      });
    },
    // 删除消息
    toDeleteAll(){
      const checkedMessages = [];
      let unRead = 0; // 有多少未读消息被删除
      for (let i = 0; i < this.messageList.length; i++) {
        if (this.messageList[i].checked) {
          checkedMessages.push({readLogId: this.messageList[i].readLogId, id: this.messageList[i].id, messageType: this.messageList[i].messageType})
          if (this.messageList[i].messageStatus === 0) { // 未读消息
            unRead++;
          }
        }
      }
      if (checkedMessages.length === 0) {
        this.$message.warning('请选择未读消息');
        return;
      }
      console.log(`批量标记 ${checkedMessages.length} 条消息为已读`);
      messageApi.deleteWarnMessage(checkedMessages).then(() => {
        this.resetMessageList();
        this.fetchMessages()
        this.$emit("readMessage", unRead);// 重新刷新未读消息
      });
    },
    /**
     * 展开/收起消息
     */
    async toggleMessageExpand(item) {
      // 切换展开状态
      item.expanded = !item.expanded;

      // 如果是展开操作且消息未读，立即标记为已读
      if (item.expanded && item.isRead === 'N') {
        console.log('展开未读消息，标记为已读:', item.title);
        await this.markMessageAsRead(item);
      }

      // 检查内容是否溢出
      if (item.expanded) {
        this.$nextTick(() => {
          this.checkContentOverflow(item);
        });
      }
    },

    /**
     * 标记单条消息为已读
     */
    async markMessageAsRead(item) {
      // 如果已经是已读状态，直接返回

    },

    /**
     * 打开消息详情对话框
     */
    async openMessageDetail(item) {
      if (item.messageStatus === 0) { // 未读
        // 将消息标记为已读
        messageApi.readWarnMessage([{readLogId: item.readLogId, id: item.id, messageType: item.messageType}]).then(() => {
          item.messageStatus = 1;
          this.$emit("readMessage", 1); // 向上级返回，已读一条
        })
      }
      // 如果是预警，打开预警详情页面
      if (item.messageType === 2) {
        await this.router.push(`/sys/warning/detail?type=view&id=${item.id}`);
        this.$emit('close');
        return;
      }
      console.log('打开消息详情:', item.title);
      console.log(item)
      // 设置当前消息并显示对话框
      this.currentMessage = { ...item };
      this.showMessageDetail = true;

      console.log('对话框状态:', this.showMessageDetail);

    },

    /**
     * 跳转到业务页面
     */
    jumpToPage(item) {
      if (!item.pagePath) {
        this.$message.warning('无跳转路径');
        return;
      }

      // 解析页面参数
      let query = {};
      if (item.pageParams) {
        try {
          query = typeof item.pageParams === 'string'
            ? JSON.parse(item.pageParams)
            : item.pageParams;
        } catch (error) {
          console.error('解析页面参数失败:', error);
        }
      }

      // 跳转
      this.$router.push({
        path: item.pagePath,
        query: query
      });

      // 关闭对话框和消息列表
      this.showMessageDetail = false;
      this.$emit('close');
    },

    /**
     * 检查内容是否溢出
     */
    checkContentOverflow(item) {
      const contentRef = this.$refs['content-' + item.id];
      if (contentRef && contentRef[0]) {
        const element = contentRef[0];
        item.hasOverflow = element.scrollHeight > 200;
        this.$forceUpdate();
      }
    },

    /**
     * 获取消息类型文本
     */
    getMessageTypeText(type) {
      if (type === 1) {
        return '系统消息';
      } else if (type === 2) {
        return '系统预警';
      } else if (type === 3) {
        return '系统公告';
      }
      return '';
    },

    /**
     * 获取级别文本
     */
    getLevelText(level) {
      const levelMap = {
        '1': '普通',
        '2': '重要',
        '3': '紧急'
      };
      return levelMap[level] || '';
    },

    /**
     * 获取状态标签类型
     */
    getStatusTagType(status) {
      const typeMap = {
        '1': 'warning',  // 待处理
        '2': 'primary',  // 处理中
        '3': 'success',  // 已处理
        '4': 'info'      // 已忽略
      };
      return typeMap[status] || 'info';
    },

    /**
     * 获取内容预览
     */
    getShortContent(content) {
      if (!content) return '';

      // 去除HTML标签
      const text = this.stripHtmlTags(content);

      // 截取前50个字符
      return text.length > 50 ? text.substring(0, 50) + '...' : text;
    },

    /**
     * 去除HTML标签
     */
    stripHtmlTags(html) {
      if (!html) return '';

      try {
        // 先将转义的引号还原
        let text = html.replace(/\\"/g, '"').replace(/\\'/g, "'");

        // 创建临时DOM元素来解析HTML
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = text;
        text = tempDiv.textContent || tempDiv.innerText || '';

        // 清理多余的空白字符
        text = text.replace(/\s+/g, ' ').trim();

        return text;
      } catch (error) {
        console.error('去除HTML标签失败:', error);
        return html;
      }
    },

    /**
     * 格式化时间
     */
    formatTime(time) {
      if (!time) return '';

      const now = new Date();
      const msgTime = new Date(time);
      const diff = now - msgTime;

      // 1分钟内
      if (diff < 60000) {
        return '刚刚';
      }

      // 1小时内
      if (diff < 3600000) {
        return Math.floor(diff / 60000) + '分钟前';
      }

      // 24小时内
      if (diff < 86400000) {
        return Math.floor(diff / 3600000) + '小时前';
      }

      // 7天内
      if (diff < 604800000) {
        return Math.floor(diff / 86400000) + '天前';
      }

      // 超过7天，显示具体日期
      return time.substring(0, 10);
    }
  }
};
</script>

<style scoped lang="scss">
.message-list {
  position: absolute;
  top: 100%;
  right: 0;
  width: 500px;
  max-height: 600px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  animation: slideDown 0.3s ease-out;

  .message-title {
    padding: 16px 20px;
    border-bottom: 1px solid var(--yq-border-color);
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-shrink: 0;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 8px 8px 0 0;
    .message-left{
      .active{
        background: var(--el-color-primary);
        border: 1px solid var(--el-color-primary);
      }
    }
    .message-left, .message-right {
      display: flex;
      align-items: center;
      gap: 8px;

      // 优化按钮样式
      :deep(.table-button) {
        padding: 0 10px;
        color: #fff;
        transition: all 0.3s;

        &:hover:not(:disabled) {
          background: rgba(255, 255, 255, 0.3);
          border-color: rgba(255, 255, 255, 0.5);
          transform: translateY(-1px);
        }

        &:disabled {
          background: #fff;
          color: #667eea;
          border-color: #fff;
          font-weight: 600;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
        }
      }

      :deep(.el-checkbox) {
        .el-checkbox__inner {
          border-color: rgba(255, 255, 255, 0.5);
          background: rgba(255, 255, 255, 0.2);
        }

        .el-checkbox__label {
          color: #fff;
        }

        &.is-checked .el-checkbox__inner {
          border-color: #fff;
        }
      }
    }
  }

  .message-list-info {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    .message-container {
      flex: 1;
      overflow-y: auto;
      padding: 16px;

      &::-webkit-scrollbar {
        width: 6px;
      }

      &::-webkit-scrollbar-thumb {
        background: #dcdfe6;
        border-radius: 3px;

        &:hover {
          background: #c0c4cc;
        }
      }
    }

    .message-empty {
      text-align: center;
      padding: 60px 20px;
      color: #909399;

      .empty-icon {
        font-size: 48px;
        margin-bottom: 16px;
      }

      .empty-text {
        font-size: 14px;
      }
    }

    .message-item {
      background: white;
      padding: 14px;
      margin-bottom: 12px;
      border: 1px solid var(--yq-border-color);
      border-radius: 10px;
      display: flex;
      align-items: flex-start;
      cursor: pointer;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);

      &:first-child {
        margin-top: 0;
      }

      &:last-child {
        margin-bottom: 0;
      }

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
        border-color: #409eff;
      }

      .message-status {
        margin-right: 8px;
        margin-top: 2px;
        display: flex;
        align-items: center;
        flex-direction: column;
        width: 12px;
        .status-badge {
          display: inline-block;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          flex-shrink: 0;
        }
        .status-type{
          font-size: 12px;
          color: #ccc;
          margin-top: 4px;
        }

        .unread-badge {
          background: var(--el-color-danger);
          box-shadow: 0 0 0 2px rgba(245, 108, 108, 0.2);
          animation: pulse-unread 2s ease-in-out infinite;
        }

        .read-badge {
          background: #e4e7ed;
          border: 1px solid #dcdfe6;
        }
      }

      .message-check {
        margin-right: 10px;
        margin-top: 2px;
      }

      .message-detail {
        flex: 1;
        overflow: hidden;

        .detail-header {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          margin-bottom: 6px;
          gap: 8px;

          .detail-title {
            flex: 1;
            min-width: 0;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            gap: 6px;

            .message-type-tag {
              display: inline-block;
              padding: 3px 10px;
              font-size: 12px;
              border-radius: 12px;
              font-weight: 500;
              color: #fff;
              flex-shrink: 0;

              &.tag-1 {
                background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
              }

              &.tag-2 {
                background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
              }

              &.tag-message {
                background: linear-gradient(135deg, #a8edea 0%, #fed6e3 100%);
              }
            }

            .warn-tag {
              flex-shrink: 0;
            }

            .message-level-tag {
              display: inline-block;
              padding: 3px 8px;
              font-size: 11px;
              border-radius: 10px;
              font-weight: 500;
              flex-shrink: 0;

              &.level-2 {
                background: linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%);
                color: #e67e22;
              }

              &.level-3 {
                background: linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%);
                color: #e74c3c;
                font-weight: 600;
                animation: shake 0.5s infinite;
              }
            }

            .title-text {
              font-size: 14px;
              font-weight: 500;
              flex: 1;
              min-width: 0;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            .expand-icon {
              font-size: 14px;
              color: #999;
              margin-left: 4px;
              transition: transform 0.3s;
              flex-shrink: 0;
            }
          }

          .detail-time {
            font-size: 12px;
            color: #999;
            white-space: nowrap;
            flex-shrink: 0;
            min-width: fit-content;
          }
        }

        .detail-info {
          font-size: 12px;
          color: #666;
          line-height: 1.5;
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          gap: 10px;

          .content-preview {
            flex: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }

          .view-detail-btn {
            color: #409eff;
            cursor: pointer;
            font-size: 12px;
            white-space: nowrap;
            flex-shrink: 0;
            transition: all 0.3s;

            &:hover {
              color: #66b1ff;
              text-decoration: underline;
            }
          }
        }

        .detail-content {
          margin-top: 10px;
          padding-top: 10px;
          border-top: 1px dashed var(--yq-border-color);

          .content-full-wrapper {
            position: relative;
            max-height: 200px;
            overflow: hidden;
            margin-bottom: 10px;

            &.has-overflow::after {
              content: '';
              position: absolute;
              bottom: 0;
              left: 0;
              right: 0;
              height: 40px;
              background: linear-gradient(to bottom, transparent, #fff);
              pointer-events: none;
            }
          }

          .content-full {
            font-size: 13px;
            color: #333;
            line-height: 1.8;
            white-space: pre-wrap;
            word-break: break-word;

            :deep(img) {
              max-width: 100%;
              height: auto;
              display: block;
              margin: 10px 0;
              border-radius: 4px;
            }

            :deep(p) {
              margin: 8px 0;
              line-height: 1.8;
            }

            :deep(a) {
              color: #409eff;
              text-decoration: none;

              &:hover {
                text-decoration: underline;
              }
            }

            :deep(ul), :deep(ol) {
              padding-left: 20px;
              margin: 8px 0;
            }

            :deep(li) {
              margin: 4px 0;
            }

            :deep(strong) {
              font-weight: 600;
            }

            :deep(h1), :deep(h2), :deep(h3), :deep(h4), :deep(h5), :deep(h6) {
              margin: 12px 0 8px;
              font-weight: 600;
            }

            :deep(hr) {
              border: none;
              border-top: 1px solid #e4e7ed;
              margin: 16px 0;
            }
          }

          .content-meta {
            display: flex;
            gap: 20px;
            font-size: 12px;
            color: #999;
            padding-top: 8px;
            border-top: 1px solid #f0f0f0;
            flex-wrap: wrap;

            span {
              display: flex;
              align-items: center;
              gap: 4px;
            }
          }

          .detail-actions {
            margin-top: 12px;
            padding-top: 12px;
            border-top: 1px solid #f0f0f0;
            text-align: center;
            display: flex;
            justify-content: center;
            gap: 16px;

            .view-detail-btn,
            .jump-btn {
              color: #409eff;
              cursor: pointer;
              font-size: 13px;
              transition: all 0.3s;
              display: inline-block;

              &:hover {
                color: #66b1ff;
                text-decoration: underline;
              }
            }
          }
        }
      }

      &.expanded {
        .message-detail {
          .detail-header .detail-title .expand-icon {
            transform: rotate(180deg);
          }
        }
      }

      &.read {
        background: #f8f9fa;
        opacity: 0.85;

        .message-detail {
          .detail-header .detail-title .title-text {
            color: #909399;
          }

          .detail-info {
            color: #a8abb2;
          }

          .detail-content .content-full-wrapper.has-overflow::after {
            background: linear-gradient(to bottom, transparent, #f8f9fa);
          }
        }

        &:hover {
          opacity: 1;
        }
      }
    }

    .message-loading {
      text-align: center;
      padding: 15px;
      color: #999;
      font-size: 14px;
    }

    .message-no-more {
      text-align: center;
      padding: 15px;
      color: #999;
      font-size: 12px;
    }
  }
}

// 动画
@keyframes pulse-unread {
  0% {
    box-shadow: 0 0 0 0 rgba(245, 108, 108, 0.4);
  }
  50% {
    box-shadow: 0 0 0 4px rgba(245, 108, 108, 0.1);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(245, 108, 108, 0);
  }
}

@keyframes slideDown {
  0% {
    opacity: 0;
    transform: translateY(-20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes shake {
  0%, 100% {
    transform: translateX(0);
  }
  25% {
    transform: translateX(-2px);
  }
  75% {
    transform: translateX(2px);
  }
}

// 对话框样式
:deep(.message-detail-dialog) {
  .el-dialog__header {
    padding: 20px 24px;
    border-bottom: 1px solid var(--yq-border-color);

    .el-dialog__title {
      font-size: 18px;
      font-weight: 600;
      color: #303133;
    }

    .el-dialog__headerbtn {
      top: 20px;

      .el-dialog__close {
        font-size: 20px;
        color: #909399;

        &:hover {
          color: #409eff;
        }
      }
    }
  }

  .el-dialog__body {
    padding: 24px;
    max-height: 70vh;
    overflow-y: auto;

    .dialog-header-info {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 16px;
      flex-wrap: wrap;
    }

    .dialog-content {
      font-size: 14px;
      line-height: 1.8;
      color: #606266;

      :deep(img) {
        max-width: 100%;
        height: auto;
        display: block;
        margin: 16px 0;
        border-radius: 4px;
      }

      :deep(p) {
        margin: 12px 0;
      }

      :deep(ul), :deep(ol) {
        padding-left: 24px;
        margin: 12px 0;
      }

      :deep(hr) {
        border: none;
        border-top: 1px solid #e4e7ed;
        margin: 20px 0;
      }
    }

    .dialog-meta {
      margin-top: 24px;
      padding-top: 16px;
      border-top: 1px solid #f0f0f0;
      font-size: 13px;
      color: #909399;

      div {
        margin-bottom: 8px;

        &:last-child {
          margin-bottom: 0;
        }

        label {
          font-weight: 500;
          color: #606266;
        }
      }
    }
  }

  .el-dialog__footer {
    padding: 16px 24px;
    border-top: 1px solid var(--yq-border-color);
    text-align: right;
  }
}
</style>

